import { Link } from "react-router-dom";

const DRIVERS = [
  { icon: "ri-hotel-line", title: "Luxury Resort Accommodation", desc: "Premium nightly stays across the resort." },
  { icon: "ri-team-line", title: "Corporate Retreats & Conferences", desc: "Purpose-built spaces for business gatherings." },
  { icon: "ri-heart-3-line", title: "Destination Weddings", desc: "Scenic venues for unforgettable celebrations." },
  { icon: "ri-community-line", title: "Private Celebrations & Events", desc: "Birthdays, anniversaries and special occasions." },
  { icon: "ri-restaurant-line", title: "Food & Beverage Revenue", desc: "Dining experiences that add to earnings." },
  { icon: "ri-heart-pulse-line", title: "Wellness & Leisure Tourism", desc: "Restorative stays for wellness travellers." },
  { icon: "ri-riding-line", title: "Weekend Getaways", desc: "Short-break escapes that keep occupancy high." },
];

export default function RevenueDrivers() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-8 md:gap-14">
          <div className="lg:w-1/3 relative">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-stack-line"></i> Revenue Drivers
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
              Multiple Streams, <span className="italic text-primary-700">One Asset</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Your villa taps into several booming hospitality segments at once — so returns
              don&apos;t depend on a single source.
            </p>
            <Link
              to="/returns"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
            >
              See How Returns Stack Up
              <i className="ri-arrow-right-line"></i>
            </Link>
            <div className="mt-6 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Outdoor%20destination%20wedding%20dinner%20set%20up%20in%20a%20forest%20resort%20with%20warm%20string%20lights%20and%20long%20wooden%20tables%2C%20elegant%20decor%2C%20evening%20ambience%2C%20luxury%20hospitality%2C%20warm%20green%20and%20gold%20tones%2C%20premium%20event%20photography&width=900&height=700&seq=revenue-nomad-1&orientation=landscape"
                alt="Outdoor destination wedding setup in a forest resort"
                className="w-full h-56 md:h-72 object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {DRIVERS.map((driver) => (
              <div
                key={driver.title}
                className="flex items-start gap-4 rounded-2xl bg-background-50 border border-background-200 p-5 md:p-6"
              >
                <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-primary-100 text-primary-700 shrink-0">
                  <i className={`${driver.icon} text-xl`}></i>
                </span>
                <div>
                  <h4 className="text-sm font-bold text-foreground-950">{driver.title}</h4>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{driver.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}